import logo from "../../assets/img/logos/Logo-IAmInterviewed-white.png";
import { useHistory } from "react-router";
import { MouseEvent } from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const FooterOuter = () => {
    const history = useHistory();
    const register = (event: MouseEvent, registerType: string) => {
        event.preventDefault();
        history.push("/register/" + registerType);
    };

    const homeRedirect = (event: MouseEvent) => {
        event.preventDefault();
        history.push("/index");
    };

    return (
        <footer>
            <div className="container">
                <div className="row mt-n1-9">
                    <div className="col-lg-4 col-md-6">
                        <img className="footer-logo" alt="IAmInterviewwed Logo" src={logo} onClick={(e) => { homeRedirect(e); }}></img>
                        <p className="mt-4 text-light-gray">IamInterviewed is Technical Interview platform. It helps Companies to choose right talent with minimum efforts there by reducing the Time and Cost.
                            IamInterviewed also helps candidate's to standout with Technical Skill rating to catch the attention of the companies and Recruiters.</p>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h3 className="text-white">Know Us</h3>
                        <ul className="footer-list ps-0">
                            <li><a onClick={(e) => { history.push("/testimonials") }}>Testimonials</a></li>
                            <li><a onClick={(e) => { history.push("/about-us") }}>About Us</a></li>
                            <li><a onClick={(e) => { history.push("/faqs") }}>FAQ's</a></li>
                            <li><a onClick={(e) => { history.push("/privacy-policy") }} target="_blank">Privacy Policy</a></li>
                            <li><a onClick={(e) => { history.push("/blogs") }} target="_blank">Blogs</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h3 className="text-white">Useful Links</h3>
                        <ul className="footer-list ps-0">
                            <li><a onClick={(e) => { register(e, "Candidate"); }}>Candidate</a></li>
                            <li><a onClick={(e) => { register(e, "Interviewer"); }}>Interviewer</a></li>
                            <li><a onClick={(e) => { register(e, "Company"); }}>Employer</a></li>
                            <li><a onClick={(e) => { homeRedirect(e); }}>IamInterviewed</a></li>
                            <li><a onClick={(e) => { history.push("/site-map") }}>Sitemap</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-2 col-md-6 contact-mobile">
                        <h3 className="text-white">Contact Us</h3>
                        <p className="mt-4 text-light-gray">
                            #226, 10 M,<br />
                            100 Ft Road, HRBR Layout,<br />
                            Block 1, Kalyan Nagar,<br />
                            Bangalore - 560 043. India.</p>
                    </div>

                    <div className="footer-sm-wrpapper">
                        <h3 className="text-white display-in">Get in touch</h3>
                        <ul className="footer-list-sm ps-0">
                            <li><a href="mailto:info@iaminterviewed.com"><MailOutlineIcon /></a></li>
                            <li><a href="https://www.linkedin.com/company/iaminterviewed/" target="_blank"><LinkedInIcon /></a></li>
                            <li><a href="#" target="_blank"><InstagramIcon /></a></li>
                            <li><a href="#" target="_blank"><YouTubeIcon /></a></li>
                        </ul>
                    </div>
                </div>
            </div>


            <div className="footer-bar text-center">
                &copy; <span>{new Date().getFullYear()}</span> <a href="https://anterntech.com/" target="_blank">Antern Technologies</a>
            </div>
        </footer>
    );
};
export default FooterOuter; 